import { render, staticRenderFns } from "./Block3.vue?vue&type=template&id=61f39a56"
import script from "./Block3.vue?vue&type=script&lang=js"
export * from "./Block3.vue?vue&type=script&lang=js"
import style0 from "./Block3.vue?vue&type=style&index=0&id=61f39a56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports